import {http} from "../../Services/Http/HttpClient";
import FilterBuilder from "../../Services/Filters/FilterBuilder";

export const getFinanceExpensesList = async (filters: any = {}, sort: string = ''): Promise<unknown> => {
    filters = {
        ...filters,
        sort: sort
    }
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    return await http.get('/admin/finance/resume' + (queryParams ? '?' + queryParams : ''))
}

export const resumeExport = async (month: number, year: number): Promise<unknown> => {
    return await http.get(`/admin/finance/resume-export/${month}/${year}`)
}

export const revenueReport = async (filters: any = {}): Promise<unknown> => {
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    return await http.get(`/admin/finance/economic-performance` + (queryParams ? '?' + queryParams : ''))
}
